export default __webpack_public_path__ + "static/media/ninja_bg.3ccdbec0.png";